export class FaceNormal {
    constructor(
        readonly x: number,
        readonly y: number,
        readonly z: number,
    ) {}
}
